module.exports = __webpack_public_path__ + "img/working_time.62efc2eb.png";